import * as React from 'react';
import {
    Typography, Collapse, Stack, Divider, Card, IconButton, Grid,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Popover, Link, Box, CardActionArea,
    TableCell, TableBody, TableRow, Table, TableContainer, TableHead,
} from '@mui/material'

import InfoIcon from '@mui/icons-material/Info';
import {WinIcon, LoseIcon, EmptyIcon} from 'assets/Icons';
import PercentageCard from './PercentageCard';
import {disp_rank, shortenUsername, prev_rank, next_rank} from 'assets/utils';
import { Adsense } from '@ctrl/react-adsense';
import SeriesIcon from 'components/SeriesIcon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import SwapVertIcon from '@mui/icons-material/SwapVert';
import { FixMeButton } from './FixMe';

import { styled, useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ParticipantsIcon from 'components/ParticipantsIcon';
import PointsIcon from 'components/PointsIcon';
import { fetchData } from 'assets/utils';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { More } from '@mui/icons-material';
import { PredictionCard } from './UserCard';
import DisclaimerBox from 'components/DisclaimerBox';
import InfoBox from 'components/InfoBox';
import ShadowBox from 'components/ShadowBox';
import OutlinedBox from 'components/OutlinedBox';
import { useTranslation, Trans } from "react-i18next";


function getSortedResults(results, sort) {
  if (sort === "score") {
    return results;
  } else {
    return results.slice().sort((l, r) => r["week"] !== undefined ? r["week"].localeCompare(l["week"]) : 1);
  }
}

export default ({is_single, data, name, handleFix}) => {

  const theme = useTheme();
  const { t } = useTranslation();

    const [open, setOpen] = React.useState(false);
    const [sort, setSort] = React.useState("score");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const valid_scores = data["results"].filter(el => el["selected"] == 1);
    const valid_scores_sum = valid_scores.length == 0 ? 0 : Math.round(100*valid_scores.reduce((partialSum, a) => partialSum + a["score"], 0)/(is_single ? valid_scores.length : 1))/100;

    const show_popover_brackets = is_single;

    const sortedResults = getSortedResults(data["results"], sort);

    const minRank = data.sub_category.length > 1 ? 1 : 3;
    const maxRank = data.sub_category.length > 1 ? 30 : 115;

    const firstMark = Math.max(minRank, prev_rank(data["current_rank"], data.sub_category.length == 1));
    const lastMark = Math.min(Math.max(next_rank(next_rank(next_rank(data["current_rank"]))), next_rank(data["predicted_rank"]), data["current_rank"], next_rank(data["predicted_rank"])), maxRank);

    return  <>
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"

      sx={{mt: 5, mb: 2}}
    >
      <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" id={is_single ? "singles" : "doubles"}>
        {t("calculation.title", {type: is_single ? t("common.singles") : t("common.doubles")})}
      </Typography>
      <IconButton aria-label="Example" color="primary" onClick={handleClickOpen}>
      <InfoIcon/>
      </IconButton>
    </Stack>

    <PredictionCard
      rank={data["current_rank"]}
      predRank={data["predicted_rank"]}
      eloRank={data["elo_rank"]}
      sub={data["sub_category"]}
      label={is_single ? t("common.singlesLower") : t("common.doublesLower")}
      isSingles={is_single}
      title={t("prediction.titleSimple")}
      firstMark={firstMark}
      lastMark={lastMark}
      rankData={data}
    />

      {is_single ? <>
      <ShadowBox sx={{mt: 1}} elevation={0}>
            <Typography sx={{ p: 2 }} component="div" variant="body2">
              {t("calculation.score")}
              <Typography variant="body2" display="inline" sx={{fontWeight: "bold", marginLeft: '5px'}} color="primary" >{data["score"]}</Typography>
              <Typography display="inline" variant="body2" sx={{fontWeight: "bold"}} color="text.primary_bold"> = </Typography> 
              <Typography display="inline" variant="body2" sx={{fontWeight: "bold"}} color="secondary">{100*data["score_factor"]}%</Typography> 
              <Typography display="inline" variant="body2" sx={{fontWeight: "bold"}} color="text.primary_bold"> &middot; </Typography> 
              <Typography display="inline" variant="body2" sx={{fontWeight: "bold"}} color="primary">{valid_scores_sum}</Typography>
            </Typography>

            <Divider sx={{width: "100%"}}/>
            
            <Typography sx={{ p: 2 }} component="div" variant="body2">
              <Typography variant="body2" display="inline" sx={{fontWeight: "bold"}} color="secondary">{100*data["score_factor"]}%</Typography>
              <Typography variant="body2" display="inline" sx={{fontWeight: "bold"}} color="text.primary_bold">: {valid_scores.length}</Typography> {t("calculation.resultsWithPoints", {count: valid_scores.length})}
              
            </Typography>

            {valid_scores.length > 1 ? <> <Divider/>
            <Typography sx={{ p: 2}} component="div" variant="body2">
              <Typography display="inline" sx={{fontWeight: "bold"}} color="primary" component="span" variant="body2">{valid_scores_sum}</Typography>
              <Typography display="inline" sx={{fontWeight: "bold"}} color="text.primary_bold" variant="body2"> = {show_popover_brackets ? "( " : ""}</Typography>

              {valid_scores.map((el, index) => {
                return <React.Fragment key={el["title"] + el["subtitle"] + el["score"]}>
                    <Typography display="inline" sx={{fontWeight: "bold"}} variant="body2" color="primary">{el["score"]}</Typography>
                    {index < valid_scores.length -1 ? <Typography variant="body2" display="inline" sx={{fontWeight: "bold"}} color="text.primary_bold"> + </Typography> : null}
                </React.Fragment>
              })}
              
              {show_popover_brackets ? <Typography variant="body2" display="inline" sx={{fontWeight: "bold"}} color="text.primary_bold"> ) &frasl; {valid_scores.length}</Typography> : null}
            </Typography></> : null}

            {data["notes"].map(note => <React.Fragment key={note}> <Divider/><Typography sx={{ p: 2 }} component="div" variant="body2" dangerouslySetInnerHTML={{__html: note}}></Typography></React.Fragment>)}
    </ShadowBox>

    <InfoBox title={t("calculation.infoTitle")} color={theme.palette.primary.main} titleColor={theme.palette.primary.dark} backgroundColor="#F6FBFF">
      <Trans i18nKey="calculation.infoSingles" components={{
        b: <b style={{color: theme.palette.primary.dark}} />,
        gap: <span style={{height: "8px", display: "block"}} />
      }} />
    </InfoBox>

    <DisclaimerBox/>


    </> : <>
    
    {valid_scores.length > 1 || data["notes"].length > 0 ? <ShadowBox sx={{mt: 1}}>
            <Typography sx={{ p: 2}} component="div" variant="body2">
              {t("calculation.score")} <Typography display="inline" sx={{fontWeight: "bold"}} variant="body2" color="primary" component="span">{valid_scores_sum}</Typography>
              <Typography display="inline" sx={{fontWeight: "bold"}} variant="body2" color="text.primary_bold"> = {show_popover_brackets ? "( " : ""}</Typography>

              {valid_scores.map((el, index) => {
                return <React.Fragment key={el["title"] + el["subtitle"] + el["score"]}>
                    <Typography variant="body2" display="inline" sx={{fontWeight: "bold"}} color="primary">{el["score"]}</Typography>
                    {index < valid_scores.length -1 ? <Typography display="inline" sx={{fontWeight: "bold"}} color="text.primary_bold"> + </Typography> : null}
                </React.Fragment>
              })}
              
              {show_popover_brackets ? <Typography variant="body2" display="inline" sx={{fontWeight: "bold"}} color="text.primary_bold"> ) &frasl; {valid_scores.length}</Typography> : null}
            </Typography>

            <Divider/>
            <Typography sx={{ p: 2 }} component="div" variant="body2">
              <Typography display="inline" sx={{fontWeight: "bold"}} variant="body2" color="secondary" component="span">NR</Typography><b>: {valid_scores.length}</b>&nbsp;{t("calculation.resultsWithPoints", {count: valid_scores.length})}
            </Typography>

            {data["notes"].map(note => <> <Divider/><Typography sx={{ p: 2 }} component="div" variant="body2" dangerouslySetInnerHTML={{__html: note}}></Typography></>)}
    </ShadowBox> : null}

    <InfoBox title={t("calculation.infoTitle")} color={theme.palette.primary.main} titleColor={theme.palette.primary.dark} backgroundColor="#F6FBFF">
      <Trans i18nKey="calculation.infoDoubles" components={{
        b: <b style={{color: theme.palette.primary.dark}} />,
        gap: <span style={{height: "8px", display: "block"}} />
      }} />
    </InfoBox>
    
    </>}
      
    

    {/*<Box sx={{marginTop: '30px', marginBottom: '30px'}}>
            <Adsense
              client="ca-pub-9305958838449958"
              slot="4567492781"
              style={{ display: 'block'}}
              layoutKey='-e5+6h-32-8b+ql'
              layout="in-article"
              format="fluid"
            />
            </Box>*/}

    
    <ShadowBox sx={{mt: 4, mb: 1, backgroundColor: "primary.main"}}>

       <Grid sx={{pl: 2, height: 60}}  container alignItems="center" justifyContent="space-between">
              
              <Stack>
            <Typography variant="body" color="common.white" sx={{fontWeight: "bold"}}>
              {t("calculation.results")}
            </Typography>
            <Typography variant='caption' color="common.white">
                {name} ({disp_rank(data["current_rank"], data["sub_category"])})
              </Typography>
            </Stack>

            <Box>
            <SortButton sort={sort} setSort={setSort}/>
            <FixMeButton handleFix={handleFix}/>
            </Box>
         
        </Grid>
    </ShadowBox>

        {data["results"].length == 0 ? <OutlinedBox>
          <Typography variant='body2' component="div" sx={{padding: 1, fontStyle: "italic", textAlign: "center", color: "text.secondary"}}>{t("calculation.noResults")}</Typography></OutlinedBox> : null}

        {sortedResults.map((el, index) => <ResultLine key={el["title"] + el["subtitle"] + el["score"] + el["series"]} data={el} index={index} />)}

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{is_single ? t("calculation.dialogTitleSingles") : t("calculation.dialogTitleDoubles")}</DialogTitle>
            <DialogContent>
            {is_single ? <DialogContentText>
                <Trans i18nKey="calculation.dialogSingles" components={{
                    br: <br/>,
                    s: <Typography color="secondary" style={{fontWeight: "bold"}} display="inline" />,
                    link: <Link underline="none" sx={{fontWeight: "bold"}} href="https://www.tennisenpadelvlaanderen.be/tennis/klassementen" color="primary" />
                }} />
            </DialogContentText> :
            <DialogContentText>
                <Trans i18nKey="calculation.dialogDoubles" components={{
                    br: <br/>,
                    n: <Typography color="text.primary_bold" style={{fontWeight: "bold"}} display="inline" />,
                    s: <Typography color="secondary" style={{fontWeight: "bold"}} display="inline" />,
                    p: <Typography color="primary" style={{fontWeight: "bold"}} display="inline" />,
                    link: <Link underline="none" sx={{fontWeight: "bold"}} href="https://www.tennisenpadelvlaanderen.be/tennis/klassementen" color="primary" />
                }} />
            </DialogContentText>
            }
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>{t("common.close")}</Button>
            </DialogActions>
        </Dialog>
        
  </>
}


const CustomButton = styled(Button)({
  width: '100%',
  boxShadow: 'none',
  textTransform: 'none',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#FFFFFF',
  },
});

const WinLoseIcon = ({type}) => {
  if (type == "W") {
    return  <WinIcon />;
  } else if (type == "L") {
    return <LoseIcon />
  //} else if (type == "WI") {
    //return  <WinIconInvalid />
  //} else if (type == "LI") {
    //return <LoseIconInvalid />
  } else if (type == "|") {
    return <Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 4, marginLeft: 1}}/>
  } else if (type == "G") {
    return <EmptyIcon/>
  }
}

function RoundName({data}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const id = data?.p_id;
  
  const navigateToUser = () => {
      fetchData(id, null, (content) => {
          navigate("/speler/" + id, {
              state: { ...content, ts: new Date().getTime() },
          });
      });
  };

  const theme = useTheme();

  return <>
    {data["rn"]}
    {data["p_name"] && data["p_name"].length > 0 ? <>
      {" " + t("common.with") + " "}
      <b style={{
            fontWeight: "bold",
            color: theme.palette.primary.main,
            cursor: id ? "pointer" : "default",
            "&:hover": id ? { color: theme.palette.primary.dark } : {},
          }} 
          onClick={id ? navigateToUser : null} color="primary">{shortenUsername(data["p_name"])}</b>
    </> : null}
  </>
}

const ResultLine = ({data, index}) => {

    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);

    const theme = useTheme();
    return <>
      <ShadowBox
          sx={{
            p: 0, 
            mt: 1,
            mb: 1
        }}
        >
        <Stack sx={{width: "100%", alignItems: "flex-start", pt: 1}} >

            <Stack sx={{justifyContent: "space-between", flexDirection: "row", alignItems: "center", width: "100%", px: 1}}>
              <Typography variant="caption" component="div" color="#a0a0a0">
                    {data.participants ? <>
                      <ParticipantsIcon participants={data.participants} color="#a0a0a0"/>
                      <Typography variant="caption" component="span"  color="#a0a0a0" sx={{fontSize: 12, marginRight: "3px", marginLeft: "3px"}}>
                        {"\u2022"}
                      </Typography>
                    </>: null}
                    {data["rn"] ? <RoundName data={data} /> : data["subtitle"]}
                </Typography>
                <Typography variant="caption" component="div" color="#a0a0a0">
                    {data["date"] ? new Date(data["date"]).toLocaleDateString(t("dates.locale"), {day: "numeric", month: "short", year: "2-digit"}) : null}
                </Typography>
            </Stack>

              
              <Typography variant="body2" component="div" sx={{fontWeight: "bold", fontSize: 14, lineHeight: "1em", mb: 1, mt: 0.5, px: 1}} color="text.primary_bold">
                {data["title"].toUpperCase()} {data["format"] == "SMALL" ? <b style={{color: "#999", paddingLeft: "2px"}}>SMALL</b> : null}
              </Typography>

            <Divider width="100%"/>
            
            <Stack 
            onClick={()=>{setOpen(!open)}}
            sx={{
              justifyContent: "space-between", flexDirection: "row", alignItems: "center", width: "100%", py: 1, px: 1, 
              '&:hover': {cursor: "pointer"}
              }}>
            <Box sx={{display: "flex", alignItems: "center"}}>
            {data.series? <>
              <SeriesIcon series={data.series.substring(1).toUpperCase()} singles={data.series.substring(0,1) == "e"}/>
              <Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 5, marginLeft: 0}}/>
            </> : null}
            <PointsIcon points={data["score"]} finished={data["finished"]} selected={data["selected"]}/>

            <Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 5, marginLeft: 5}}/>

            {"WL" in data ? data["WL"].map((el, index) => <WinLoseIcon key={el + index} type={el} />) : null}
              
            {/*<InfoIcon style={{marginLeft: "2px", color: "#ccc"}}/>*/}
            </Box>

            {open ? <KeyboardArrowUpIcon style={{marginLeft: "2px", color: "#ccc"}}/> : <KeyboardArrowDownIcon style={{marginLeft: "2px", color: "#ccc"}}/>}
            </Stack>

        </Stack>

        <Collapse in={open} sx={{width: "100%"}} unmountOnExit>
          <Box sx={{display: "flex", justifyContent: "center", flexDirection: "column", px: 1, width: "100%"}}>
            {"matches" in data ? <MatchResults matches={data["matches"]} /> : null}

          <TournamentResult data={data}/>

          {data["url"] ? <Button sx={{display: "flex", alignSelf: "center", mb: 1, mt: -1}} onClick={() => window.open(data["url"])}>{t("calculation.toTable")}</Button> : null}
          </Box>
        </Collapse>

        </ShadowBox>
        
        
        

    
    
    
  </>
}

const CustomBox = styled(Box)({
  border: "1px solid lightgray",
  borderRadius: 5,
});

function Literal({literal}) {
  const theme = useTheme()
  return [
    <span key="1" style={{color: theme.palette.secondary.main}}>{literal[0]}</span>,
    <span key="2" style={{color: theme.palette.text.secondary, marginLeft: "5px", marginRight: "5px"}}>{"\u0078"}</span>,
    <span key="3" style={{color: theme.palette.primary.main}}>{literal[1]}</span>
  ]
}

const TournamentResult = ({data}) => {
  const { t } = useTranslation();
  const theme = useTheme()
  return <TableContainer component={CustomBox} sx={{mt: 1, mb: 2}}>
  <Table sx={{p: 0}} size="small" aria-label="a dense table">
    <TableHead>
      <TableRow>
        <TableCell sx={{p: 1}}></TableCell>
        <TableCell align="right" sx={{fontWeight: "bold", color: "text.primary_bold"}}>{t("common.points")}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>

        {data["subscores"].map((el, index) => {
                return <TableRow 
                        key={el["title"] + el["score"] + index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell sx={{p: 1, color: "text.primary_bold"}}>
                          <Typography variant="body2" component="div"  color="text.primary">
                          {el["title"]}
                          </Typography>
          </TableCell>
        <TableCell align="right" sx={{fontWeight: "bold", color: "primary.main"}}>
          <Typography variant="body2" component="div"  color="primary.main" sx={{fontWeight: "bold"}}>
              {el["literal"] ? <Literal literal={el["literal"]}/> : el["score"]}
          </Typography>

        </TableCell>
                    </TableRow>
            })}
      
    </TableBody>
  </Table>
</TableContainer>
}

const MatchResults = ({matches}) => {
  return <CustomBox sx={{mt: 2}}>
    {matches.map((el, index) => <MatchResult key={el.round + "-" + index} match={el}/>)}
  </CustomBox>

}

const MatchResult = ({match}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const num_opponents = match["opponents"].length

    const navigate = useNavigate();

    return <Box p={1} onClick={() => num_opponents == 1 ? navigate('/speler/' + match.opponents[0].player_id) : null} display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: "1px solid lightgray" ,'&:last-child': { borderBottom: 0 }, cursor: num_opponents == 1 ? "pointer" : undefined }}>
    <Box display="flex" flexDirection="column">
    {match["opponents"].map(opponent => <Typography key={opponent["player_id"]} sx={{cursor: "pointer", lineHeight: 1.5}} onClick={() => navigate('/speler/' + opponent.player_id)} variant="caption" fontWeight="bold" color="primary.main">
      {shortenUsername(opponent["name"])}{num_opponents > 1 ? <b style={{color: theme.palette.text.secondary}}>&nbsp;&nbsp;{opponent.rank} {t("common.pts")}</b> : null}
    </Typography>)}
    
    <Typography variant="caption" color="text.secondary" lineHeight={1.4}>
      {num_opponents == 1 ? <b style={{color: theme.palette.text.secondary}}>{match.opponents[0].rank} {t("common.pts")} • </b> : null}{match.round}
    </Typography>
    </Box>
    <Box display="flex" alignItems="center" flexDirection="row" justifyContent="center">
      <Typography variant="caption" color="text.secondary" fontWeight="bold" px={1} pt='1px'>
        {match.score}
      </Typography>
      {match["did_win"] == 1 ? <WinIcon/> : <LoseIcon/>}
    </Box>
  </Box>
}

function SortButton ({sort, setSort}) {

  const { t } = useTranslation();

  const updateSort = () => {
    setSort(sort === "score" ? "week" : "score")
  }

  return <Button onClick={updateSort}>
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <SwapVertIcon sx={{color: "white", display: "block", mt: 0.5}} fontSize="small" viewBox="2 2 20 20"/>
      <Typography variant="caption" color="common.white" sx={{fontWeight: "bold", textTransform: "capitalize", display: "block"}}>
        {sort === "score" ? t("calculation.sortScore") : t("calculation.sortWeek")}
      </Typography>
    </Box>

  </Button>
}